import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-left: 1px solid ${theme.v2.colors.neutral.highMedium};
    position: relative;
    overflow: hidden;
    border-top-right-radius: 24px;
    padding: 0 32px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      position: absolute;
      padding: 0 20px;
      left: 0px;
      right: 0px;
    }
  `}
`;

export const Toolbar = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background-color: ${theme.v2.colors.neutral.highPure};
    min-height: 70px;
    box-sizing: border-box;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
      padding: 16px 0px;
    }
  `}
`;

export const ContentTitle = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;

export const ToolbarButton = styled.button`
  ${({ theme, $hideInMobile, $disabled }) => css`
    display: flex;
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 100%;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    cursor: pointer;
    height: 36px;
    justify-content: center;
    width: 36px;

    ${$hideInMobile && css`
      @media (max-width: ${theme.v2.breakpoints.lg}) {
        display: none;
      }
    `}

    ${$disabled && css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
  `}
`;

export const ChatActions = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 12px;
    }
  `}
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;

  svg {
    flex: 0 0 12px !important;
  }
`;

export const AlertCardWrapper = styled.div`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      margin-bottom: 20px;
      padding-bottom: 20px;
    }
  `}
`;

export const SkeletonWrapper = styled.div`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    margin-bottom: 20px;
    margin-top: 20px;
    padding-bottom: 20px;
  `}
`;


export const MobileLayout = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      display: none;
    }
  `}
`;

export const DesktopLayout = styled.div`
  ${({ theme }) => css`
    display: none;

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 24px 16px;
    }
  `}
`;

export const MobileFirstRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
`;

export const MobileSecondRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
`;

export const AlertCardContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    align-items: center;
    width: 100%;
    height: 50px;
    justify-content: space-between;
  `}
`;

export const AlertCardInfo = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  width: 100%;
  margin-left: 16px;
`;

export const AlertCardIconCircle = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryLowLight};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-shrink: 0;
    min-width: 40px;
    min-height: 40px;

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      min-width: 32px;
      min-height: 32px;
    }
  `}
`;

export const PriorityDot = styled.div`
  ${({ theme, $severity }) => {
    const colors = {
      critical: {
        bgColor: theme.v2.colors.feedback.problemPure,
        shadow: `drop-shadow(0 0 5px ${theme.v2.colors.feedback.problemPure});`,
      },
      warning: {
        bgColor: theme.v2.colors.feedback.attentionPure,
        shadow: `drop-shadow(0 0 5px ${theme.v2.colors.feedback.attentionPure});`,
      },
    };

    return css`
    position: absolute;
    top: 0px;
    right: 0px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${colors[$severity].bgColor};
    filter: ${colors[$severity].shadow};
  `;
  }};

`;

export const AlertCardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const AlertCardTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    display: flex;
    align-items: center;
    flex: 1;

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      flex: none;
    }
  `};
`;

export const AlertCardDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-weight: ${theme.v2.font.weights.regular};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 21px;
    letter-spacing: -0.154px;

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `};
`;

export const EmptyStateWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    height: calc(100% - 70px);
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding-bottom: 16px;
    }
  `}
`;

export const EmptyStateTitle = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;

export const EmptyStateDescription = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    max-width: 420px;
    line-height: 20px;
  `}
`;

export const Image = styled.img`
  user-select: none;
  -webkit-user-drag: none;
`;
